import React from 'react';
import Chat from "../../components/Chat/Chat";
import Thread from "../../components/Thread/Thread";
import { useEffect, useRef, useContext, useState } from "react";
import { InformationBasicContext } from "../../contexts/InformationBasicContext/InformationBasicContext";
import { ChatContext } from "../../contexts/ChatContext/ChatContext"; 
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { AuthContext } from "../../contexts/AuthContext/AuthContext"
import MobileSidebar from "../../components/MobileSidebar/MobileSidebar";
import { useMediaQuery } from "@mui/material";
import { Fab } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SplitButton from "../../components/SplitButton/SplitButton";
import { ThreadContext } from "../../contexts/Thread/ThreadContext";


const Home = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const open = Boolean(anchorEl);

    const { full_name, companies, GetInformationBasic, companySelected, setCompanySelected } = useContext(InformationBasicContext);
    const { setThread_id } = useContext(ChatContext);
    const { logout } = useContext(AuthContext);
    const { GetHistoryThreads } = useContext(ThreadContext);

    const hasFetched = useRef(false);

    const isLgUp = useMediaQuery('(min-width:1024px)');

    const resetThread = () => {
        setThread_id(null);
    };

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        logout();
    };

    useEffect(() => {
        if (hasFetched.current) return;
        GetInformationBasic();
        hasFetched.current = true;        
    }, [GetInformationBasic]);

    return (
        <div className="flex flex-col w-full">
            <div className="grid grid-cols-12 gap-4">
                <div className="hidden lg:block col-span-2 bg-white border-r-2 border-[#F4F5F7]">
                    <div className="mt-4 mr-3 text-right">
                        <Fab
                            size="small"
                            sx={{
                                width: 35, 
                                height: 35,
                                backgroundColor: "rgb(85, 94, 238)",
                                color: "#ffffff",
                                boxShadow: 'none',
                                '&:hover': {
                                  backgroundColor: 'rgb(85, 94, 238)',
                                  boxShadow: 'none',
                                },
                            }}
                            onClick={resetThread}
                            >
                            <EditIcon />
                        </Fab>
                    </div>

                    <Thread/>
                </div>

                <div className="mt-2 mr-2 col-span-12 lg:col-span-10">                          
                    <div className="flex items-center justify-between w-full">
                        {!isLgUp && (
                            <IconButton 
                                onClick={() => setIsSidebarOpen(true)} 
                                aria-label="Abrir menú lateral"
                                className="float-left mt-2 ml-2 pr-4"
                                sx={{ "&:hover": { backgroundColor: "transparent !important" } }}
                            >
                                <svg stroke="#000000" xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </IconButton>
                        )}

                        <div className="flex items-center gap-2 ml-auto">
                            <SplitButton 
                                label="Empresas relacionadas"
                                items={companies}
                                companyId={companySelected}
                                setCompanySelected={setCompanySelected}
                                setThread_id={setThread_id}
                                GetHistoryThreads={GetHistoryThreads}
                            />

                            <IconButton 
                                onClick={handleOpenMenu} 
                                className="uppercase float-right"
                                sx={{ 
                                    "&:hover": { backgroundColor: "transparent !important" } 
                                }}
                            >
                                <Avatar sx={{ width: 35, height: 35, backgroundColor: "rgb(85, 94, 238)" }}>
                                    {full_name?.charAt(0) || "U"}
                                </Avatar>
                            </IconButton>

                            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                                <MenuItem sx={{ fontSize: "1rem", color: "#000000", fontWeight: 300 }}  onClick={() => { handleClose(); }}>
                                    Cerrar sesión
                                </MenuItem>
                            </Menu> 
                        </div>
                    </div>      
                   
                    <Chat/>
                </div>
            </div>

            <MobileSidebar 
                open={isSidebarOpen} 
                onClose={() => setIsSidebarOpen(false)} 
                onResetThread={resetThread}
            />
        </div>
    );
};

export default Home;
